<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'0'"></v-text-field>
      </div>
    </div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true"> Content Edit </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">Content preview</div>
      <div class="text-left content-preview" v-html="node.content"></div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Message"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <v-btn v-if="!showButtonEditor" class="d-flex mb-2" text outlined small @click="showButtonEditor = true">
      Button Text Edit
    </v-btn>
    <div v-if="!showButtonEditor && node.buttonText" class="mb-2">
      <div class="content-preview-label">Button text preview</div>
      <div class="text-left content-preview" style="color: #000000" v-html="node.buttonText"></div>
    </div>
    <va-tinymce-input
      v-if="showButtonEditor"
      class="mb-4 w-full"
      :current-content="node.buttonText"
      :editor-height="80"
      text-only
      title="Button text"
      auto-resize
      @update="content => updateButtonText(content)" />
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button background color'"
        mode="hexa"
        v-model="node.buttonColor"></VaColorPicker>
    </div>
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button text color'"
        mode="hexa"
        v-model="node.buttonTextColor"></VaColorPicker>
    </div>
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button border color'"
        mode="hexa"
        v-model="node.buttonBorderColor"></VaColorPicker>
    </div>
    <div>
      <v-text-field
        class="message-item__settings--delay panzoom-ignore"
        v-model="node.placeholderText"
        :label="'Placeholder text'"
        persistent-placeholder
        :placeholder="'e.g., 12345'"></v-text-field>
    </div>
    <div>
      <v-select
        v-model="node.zipInputDisplayType"
        :items="zipInputTypes"
        :label="'ZIP input display type'"
        persistent-placeholder
        :placeholder="'Select input type'" />
    </div>
    <div>
      <v-radio-group v-model="overrideMode" class="mb-3 radio-group-override">
        <v-radio
          label="Override ZIP only"
          :value="ZIP_OVERRIDE_MODE.ZIP_ONLY"
          color="primary"
          hide-details="auto">
        </v-radio>
        <v-radio
          label="Override ZIP and auto-determine City & State"
          :value="ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION"
          color="primary"
          hide-details="auto">
        </v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
  import VaColorPicker from "@/components/custom/VaColorPicker";
  import { ZIP_INPUT_DISPLAY_TYPES, ZIP_OVERRIDE_MODE } from "./constant";

  export default {
    name: "MultiStepFormZipInput",
    components: { VaColorPicker },

    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showEditor: !this.node?.content,
        showButtonEditor: !this.node?.buttonText,
        zipInputTypes: ZIP_INPUT_DISPLAY_TYPES,
        ZIP_OVERRIDE_MODE,
      };
    },
    computed: {
      overrideMode: {
        get() {
          if (this.node.overrideZipAndLocation) return ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION;
          if (this.node.overrideZipOnly) return ZIP_OVERRIDE_MODE.ZIP_ONLY;
          return ZIP_OVERRIDE_MODE.ZIP_ONLY;
        },
        set(value) {
          this.node.overrideZipOnly = value === ZIP_OVERRIDE_MODE.ZIP_ONLY;
          this.node.overrideZipAndLocation = value === ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION;
        },
      },
    },
    methods: {
      updateMessageContent(content) {
        this.node.content = content;
      },
      updateButtonText(content) {
        this.node.buttonText = content;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";

  .radio-group-override {
    margin-top: 0 !important;
  }

  ::v-deep .v-radio {
    .v-label {
      @include text-body-2();
      color: var(--v-body-base) !important;
    }
  }
</style>
